import React, { createContext, useContext, useState, useEffect } from 'react';

const MobileThemeContext = createContext({
  theme: 'dark',
  setTheme: () => {},
  isDark: true,
});

export const useMobileTheme = () => useContext(MobileThemeContext);

export const MobileThemeProvider = ({ children }) => {
  const [theme, setTheme] = useState(() => {
    // Check URL params first (for preview mode)
    const urlParams = new URLSearchParams(window.location.search);
    const urlTheme = urlParams.get('theme');
    if (urlTheme) return urlTheme;
    
    // Then check localStorage
    const saved = localStorage.getItem('ezparcel-mobile-theme');
    if (saved) return saved;
    
    // Default to dark for drivers (better for night driving)
    return 'dark';
  });

  useEffect(() => {
    localStorage.setItem('ezparcel-mobile-theme', theme);
  }, [theme]);

  const isDark = theme === 'dark';

  return (
    <MobileThemeContext.Provider value={{ theme, setTheme, isDark }}>
      <div className={`mobile-app ${isDark ? 'mobile-dark' : 'mobile-light'}`}>
        {children}
      </div>
    </MobileThemeContext.Provider>
  );
};

export default MobileThemeProvider;
